export default { 
    JimmyStegallDentures: process.env.REACT_APP_ENVIRONMENT === 'prod' ? 1290 : 3473,
    KoisScanBodyReference: process.env.REACT_APP_ENVIRONMENT === 'prod' ? 1291 : 3475,
    AllOnX: 1044,
    AllOnXPackage: 1214,
    DentoFacialAnalysis: 1027,
    VirtualSmileMockup: 1028
}